<template>
    <div style="padding: 10px;">
        <k-layout>
            <k-flex c12>
                <month-picker @newData="handleData($event)"></month-picker>
            </k-flex>
            <k-flex c12>
                <!-- Billing stats -->
                <k-panel title="Billing for month">
                    <div style="font-size: 1.2rem; margin-bottom: 8px;">
                        Events: {{ total_events }}
                    </div>
                    <div style="font-size: 1.2rem; margin-bottom: 8px;">
                        Total billing: {{ total_events }}
                    </div>
                    <div style="font-size: 1.2rem; margin-bottom: 8px;">
                        Billed: {{ total_events }}
                    </div>
                    <div style="font-size: 1.2rem; margin-bottom: 8px;">
                        Unbilled: {{ total_events }}
                    </div>
                    <div style="font-size: 1.2rem; margin-bottom: 8px;">
                        Expenses: {{ total_events }}
                    </div>
                    <div style="font-size: 1.2rem; margin-bottom: 8px;">
                        Profit: {{ total_billing - total_expenses }}
                    </div>
                </k-panel>
            </k-flex>
        </k-layout>
    </div>
</template>

<script>
import MonthPicker from './MonthPicker.vue'

export default {
    name: "DashboardOverview",
    data () {
    return {
        ws_channel: undefined,
        events: undefined,
        filters: {
            daterange: {
                start: 0,
                end: 0
            }
        },
        total_events: 0,
        total_billing: 0.0,
        total_billed: 0.0,
        total_unbilled: 0.0,
        total_expenses: 0.0,
    }
    },
    components: {
        MonthPicker
    },
    mounted () {
        this.connect_ws();
    },
    watch: {
        filters: {
            handler: function() {
                if (this.ws_channel) {
                    this.filter_events();
                }
            },
            deep: true
        }
    },
    computed: {},

    methods: {
        handleData(e) {
            this.filters.daterange.start = e[0];
            this.filters.daterange.end = e[1];
            console.log(this.filters);
        },
        connect_ws () {
            var self = this;
            this.ws_channel = this.$cloudserver.channel("events:all");
            this.ws_channel.on("init", function(msg) {
                self.get_events();
            });
            this.ws_channel.on("events", function(msg) {
                self.events = msg.events;
                console.log(self.events);
                filter_events();
            });
            this.ws_channel.on("event-update", function(msg) {
                self.get_events();
            });
            this.ws_channel.join();
        },
    }
}
</script>